<template>
	<div class="wrapper">
		<b-container>
			<!-- 副导航栏 -->
			<div class="little-nav flex">
				<template v-for="(item, index) in navlist">
					<div :key="index" :class="[
							'little-nav-item',
							current == index ? 'active' : '',
						]" @click="clickItem($event, item, index, item.link)" >
						<div>{{ getTitle(item.text) }}</div>
						<b-icon class="arrow" v-if="item.sub" @click="arrowCloseDrop($event)" icon="chevron-down"></b-icon>
						<b-icon v-else icon="search" class="search"></b-icon>

						<div :key="index" v-if="item.sub" class="nav-dropdown">
							<div class="dropItem" v-for="(subItem, ind) in item.sub" :key="ind"
								@click="typeClick($event ,subItem.text)">
								{{ subItem.text }}
							</div>
						</div>
					</div>
				</template>
			</div>
			<div v-for="(item, index) in dealData" :key="index">
				<layoutimgp class="layout" :hidden="false" :dataList="item.value">
					<template v-slot:title>
						<div class="title" >
							{{ item.name }} {{ $route.query.listBy == 'letter' ? '' : $t('lang.laureate') }}
						</div>
					</template>
				</layoutimgp>
			</div>
		</b-container>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				screenWidth: document.body.clientWidth,
				dataList: [],
				dealData: [],
				searchField: 'awardYear',
				flag: false,
				current: 0,
				navlist: [{
						text: 'YEAR',
						//text: this.getTitle('YEAR'),
						link: '/laureates/list?listBy=year',
						sub: [{
								text: '生物科学奖',
							},
							{
								text: '生物科学奖',
							},
						],
					},
					{
						// text: '按奖项',
						text: 'AWARDS',
						link: '/laureates/list?listBy=prize',
						sub: [{
								text: '生物科学奖',
							},
							{
								text: '计算机科学奖',
							},
						],
					},
					{
						text: 'WINNERS',
						link: '/laureates/list?listBy=letter',
					},
				],
			}
		},
		computed: {
			listenScreenWidth() {
				return this.$store.state.screenWidth
			},
		},
		watch: {
			$route: {
				handler(val) {
					//新路由
					this.init(val.query.listBy)
					// this.lisitenPath(val)
					if (val.query.name) {
						this.typeClick(name)
					}
				},
			},
			listenScreenWidth(val) {
				this.screenWidth = val
			},
		},
		created() {

			this.getCharacterYears()
			this.getCharacterDonorName()
			this.navlist.forEach(item => {
				item.checked = false
			})
			if (this.$route.query.name) {
				this.typeClick(this.$route.query.name)
				this.lisitenPath(this.$route.query.listBy)
			} else {
				this.init(this.$route.query.listBy)
			}
		},
		  
		methods: {
			arrowCloseDrop(e){
				e.target.nextSibling.style.display = 'none'
			},
			typeClick(e, text) {
				switch (this.$route.query.listBy) {
					case 'year':
						this.getcharacterList(text)
						break
					case 'prize':
						this.getcharacterList('', '', text)
						break
				}
				e.target.parentNode.style.display = 'none'
			},
		
			//获取年份
			getCharacterYears() {
				this.$api.characterYears().then((res) => {
					
					this.navlist[0].sub = res.data.map((item) => {
						return {
							text: item,
						}
					})
				})
			},
			//下拉奖项
			getCharacterDonorName() {
				this.$api.characterDonorName().then((res) => {
					this.navlist[1].sub = res.data.map((item) => {
						return {
							text: item,
						}
					})
				})
			},
			getTitle(title) {
				//中英文切换
				let str = 'lang.' + title
				return this.$t(str)
			},
			//按奖项分类
			formatArr(arr, keyword) {
				let obj = {}
				arr.forEach((item) => {
					if (Object.keys(obj).indexOf(String(item[keyword])) === -1) {
						obj[item[keyword]] = []
					}
					obj[item[keyword]].push(item)
				})
				let keyArr = []
				if (keyword == 'awardYear') {
					keyArr = Object.keys(obj).sort(function (a, b) {
						return b - a
					})
				} else if (keyword == 'firstName') {
					keyArr = Object.keys(obj).sort()
				} else {
					keyArr = Object.keys(obj)
				}
				let valueArr = []
				keyArr.forEach((item) => {
					for (let i in obj) {
						if (item == i) valueArr.push(obj[i])
					}
				})
				let newArr = keyArr.map((item, index) => {
					return {
						name: item,
						value: valueArr[index],
					}
				})
				return newArr
			},

			init(codename) {
				if (!codename) {
					this.getcharacterList()
				} else {
					this.lisitenPath(codename)
					switch (codename) {
						case 'year':
							this.getcharacterList('', '', '', 'year')
							break
						case 'prize':
							this.getcharacterList('', '', '', 'prize')
							break
						case 'letter':
							this.getcharacterList('', '', '', 'firstName')
							break
					}
				}
			},
			getcharacterList(year, initials, awardName, sortType) {

				this.$api
					.characterList({
						type: 1, //获奖人
						awardYear: year,
						firstName: initials, //首字母
						awardName: awardName,
						sortType: sortType
					})
					.then((res) => {
						this.dataList = res.data
						this.dealData = this.formatArr(
							this.dataList,
							this.searchField
						)
						console.log('处理过后的数据', this.dealData)
					})
			},
			lisitenPath(val) {
				// awardName, awardYear, firstName

				switch (val) {
					case 'year':
						this.current = 0
						this.searchField = 'awardYear'
						break
					case 'prize':
						this.current = 1
						this.searchField = 'awardName'
						break
					case 'letter':
						this.current = 2
						this.searchField = 'firstName'
						break
				}
			},
			clickItem(e, item, index, path) {
				console.dir( e)
				if (this.screenWidth < 992) {
					if (item.checked) {
						item.checked = false
					} else {
						item.checked = true
					}
				}
				// if(e.target.childNodes[2]) {
				// 	e.target.childNodes[2].style.display = 'block'
					
				// }
				e.target.childNodes[2].style.display = 'block'
				e.target.parentNode.childNodes.forEach((item, ind) => {
					if(index !== ind){
						item.childNodes[2].style.display = 'none'
					}
				})
				this.current = index
				this.$router.push(path)
			},
		},
	}
</script>
<style lang="scss" scoped>
.layout::v-deep{
	.img-wrap{
		margin: 1rem auto;
	}
}

	.little-nav {
		.little-nav-item {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0.6rem 2rem;
			margin: 1rem 0;
			border: 0.1rem solid #eee;
			cursor: pointer;
			.arrow {
				color: #9e9e9e;
			}
		}
		.little-nav-item:hover{
			.nav-dropdown{
				display: block;
			}
		} 
		.nav-dropdown {
			position: absolute;
			display: none;
			top: 2.8rem;
			left: 0;
			left: -1px;
    		width: 100.5%;
			background: #fff;
			z-index: 999;

			.dropItem {
				padding: 0.6rem 2rem;
    			border: 1px solid #ebebeb;
				border-top: none;
			}
		}
	}

	.little-nav>.little-nav-item {
		color: #c8a063;
	}

	.nav-dropdown {
		color: #9e9e9e;
	}

	.search {
		font-size: 1.6rem;
		color: #9e9e9e;
	}


	@media (min-width: 992px) {
		.little-nav {
			display: flex;
			justify-content: start;
			height: 5rem;
			line-height: 5rem;
			margin-top: 0.85rem;

			border-bottom: 0.1rem solid #eee;

			.little-nav-item {
				position: relative;
				padding: 0 2rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				margin: 0;
				border: none;
				color: #9e9e9e;

				.arrow {
					position: relative;
					top: -1.4rem;
					color: #9e9e9e;
					left: 0.1rem;
				}

				.nav-dropdown {
					position: absolute;
					display: none;
					top: 5rem;
					text-align: center;
					left: -2rem;
					.dropItem {
						padding: 0rem;
						color: #999999;
						line-height: 2.8rem;
						position: relative;
						left: 2rem;
						width: max-content;
    					border: none
					}

					.dropItem:hover {
						color: #c8a063;
					}

					cursor: pointer;
				}

				
			}
			.little-nav-item:hover,
			.little-nav-item:focus {
				.nav-dropdown {
					display: flex;
					flex-direction: column;
					align-items: center;
				}
			}

			.active {
				color: #c8a063;
				border-bottom: 0.1rem solid #c8a063;

				.arrow {
					color: #c8a063;
				}
			}
		}

		.search {
			position: relative;
			top: -2.4rem;
			left: 50rem;
			font-size: 1.8rem;
			color: #9e9e9e;
		}
	}

	.title {
		font-size: 1.4rem;
		text-align: center;
		padding: 2rem 0 1.4rem 0;
		color: #c8a063;
		font-weight: bold;
		border-bottom: 1px solid #ebebeb;
	}
</style>